export default {
  title: 'Gateway-uri de plată',
  fields: {
    name: 'Nume',
    payment_gateway: 'Gateway-uri de plată',
    live_from: 'Activ din',
    last_30_days_sales: 'Vânzări ultimele 30 zile',
    kyc_deadlines: 'Termene KYC',
    actions: 'Acțiuni',
  },
  stats: {
    active_on_stripe: 'Activ pe Stripe',
    active_on_adyen: 'Activ pe Adyen',
    adyen_verification_pending: 'Verificare Adyen în așteptare',
  },
  filters: {
    search_placeholder: 'Căutare după nume...',
    gateway_status_placeholder: 'Toate gateway-urile',
  },
  not_configured: {
    title: 'Plățile nu sunt configurate încă',
    description:
      'Niciun furnizor de plăți nu este conectat la contul dvs. Restaurantele pot fi configurate complet, dar nu pot fi activate sau accepta plăți online până când plățile sunt configurate.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (În așteptare)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verificat',
    pending: 'În așteptare',
    rejected: 'Respins',
  },
  buttons: {
    actions: 'Acțiuni',
    switch_to: 'Comutare la {{gateway}}',
    view_details: 'Vezi detalii',
    open_onboarding: 'Deschide integrarea',
    create_onboarding_link: 'Creare link de integrare',
  },
  modal: {
    title: 'Schimbare gateway de plată',
    description:
      'Sigur doriți să comutați {{companyName}} de la <bold>{{currentGateway}}</bold> la <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      '{{gateway}} nu este verificat pentru această companie. Procesarea plăților poate fi afectată.',
    confirm: 'Comutare',
    cancel: 'Anulare',
  },
  details_modal: {
    title: '{{companyName}} — Detalii gateway de plată',
    requirements: 'Cerințe',
    no_requirements: 'Nicio cerință în așteptare.',
    deadline: 'Termen limită',
    capabilities: 'Capabilități',
    onboarding_links: {
      section_title: 'Link de integrare',
      active_link: 'Link activ',
      expires: 'Expiră {{date}}',
      create_button: 'Creare link',
      extend_button: 'Extindere link',
      loading: 'Se încarcă link-urile…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Crearea link-ului de integrare a eșuat.',
    switch_success: 'Gateway-ul de plată a fost schimbat cu succes.',
    switch_failed: 'Schimbarea gateway-ului de plată a eșuat.',
    failed_to_load_data: 'Încărcarea datelor a eșuat.',
  },
};
